import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "bg-[var(--bg)]" }
const _hoisted_2 = { class: "w-full z-40" }
const _hoisted_3 = { class: "flex flex-col" }
const _hoisted_4 = { class: "min-h-screen" }
const _hoisted_5 = {
  key: 0,
  class: "bg-[var(--bg)] group"
}
const _hoisted_6 = { class: "container mx-auto px-12 text-center sm:px-24" }
const _hoisted_7 = { class: "flex flex-col justify-between w-full py-16 mb-8 sm:flex-row sm:items-start" }
const _hoisted_8 = ["href"]
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "flex space-x-12 mr-0 opacity-30 group-hover:opacity-100 transition-all duration-500 ease-in-out sm:mr-20 sm:mx-0 sm:space-x-20" }
const _hoisted_11 = { class: "text-left" }
const _hoisted_12 = { class: "space-y-2 text-xs text-[var(--text)] font-light pl-1" }
const _hoisted_13 = { class: "text-left" }
const _hoisted_14 = { class: "space-y-2 text-xs text-[var(--text)] font-light pl-1" }
const _hoisted_15 = ["href"]
const _hoisted_16 = { class: "flex justify-between items-center border-t border-[var(--border)] pt-8 pb-20" }
const _hoisted_17 = { class: "text-xs text-[var(--text-secondary)] font-light" }
const _hoisted_18 = ["src"]

import {
  defineAsyncComponent,
  computed,
  onMounted,
} from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const store = useStore();
const route = useRoute();

const NavBar = defineAsyncComponent(() => import('./components/global/nav-bar.vue'));
const Sidebar = defineAsyncComponent(() => import('@/components/global/sidebar.vue'));
const Notifications = defineAsyncComponent(() => import('@/components/global/notifications.vue'));
const NewEventModal = defineAsyncComponent(() => import('@/views/app/events/new.vue'));
const EventDetailsModal = defineAsyncComponent(() => import('@/components/global/event-details-modal.vue'));
const ModalPlanner = defineAsyncComponent(() => import('@/components/global/modal-planner.vue'));

const { VUE_APP_DG_USERS_APP } = process.env;
const usersLink = VUE_APP_DG_USERS_APP || '';
const currentYear = new Date().getFullYear();

const isHome = computed(() => route.name === 'home');
const isAuth = computed(() => store.getters['auth/isAuth']);
const showSidebar = computed(() => isAuth.value && !isHome.value);

onMounted(() => {
  if (typeof window !== 'undefined') {
    const stored = localStorage.getItem('sidebarOpen');
    if (stored !== null) {
      store.commit('setSidebar', stored === 'true');
    }
    console.log('events3->', store.state.events.events);

    // Listen for WebSocket reconnect events dispatched from visibilitychange
    window.addEventListener('reconnect-ws', ((e: Event) => {
      const payload = (e as CustomEvent).detail;
      if (payload) {
        store.dispatch('events/listWs', payload).catch(console.error);
      }
    }));
  }
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(NavBar)),
    _createVNode(_unref(Notifications)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(NewEventModal)),
      _createVNode(_unref(EventDetailsModal)),
      _createVNode(_unref(ModalPlanner)),
      (showSidebar.value && !isHome.value)
        ? (_openBlock(), _createBlock(_unref(Sidebar), { key: 0 }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      "data-scroll-container": "app-content",
      class: _normalizeClass(["overflow-y-auto transition-[padding] duration-300", 
        !isAuth.value || isHome.value
          ? 'pl-0'
          : _unref(store).state.sidebar
            ? 'sm:pl-64'
            : 'sm:pl-12'
      ])
    }, [
      _createElementVNode("main", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_view)
        ])
      ]),
      (!showSidebar.value)
        ? (_openBlock(), _createElementBlock("footer", _hoisted_5, [
            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "w-full h-px bg-line" }, null, -1)),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("a", {
                  href: `${_unref(usersLink)}`,
                  target: "_blank",
                  class: "mb-10 sm:mb-0"
                }, [
                  _createElementVNode("img", {
                    src: _ctx.isLight
              ? '/img/logo-digi-light.svg'
              : '/img/logo-digi.svg',
                    alt: "Logo",
                    class: "h-6 opacity-30 group-hover:opacity-100 courser-pointer"
                  }, null, 8, _hoisted_9)
                ], 8, _hoisted_8),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _cache[5] || (_cache[5] = _createElementVNode("h3", { class: "text-sm text-[var(--text)] font-regular mb-4" }, "Products", -1)),
                    _createElementVNode("ul", _hoisted_12, [
                      _createElementVNode("li", null, [
                        _createVNode(_component_router_link, {
                          to: isAuth.value ? '/app' : '/',
                          class: "opacity-50 hover:opacity-100 transition-all duration-300 ease-in-out"
                        }, {
                          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                            _createTextVNode(" Sky ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["to"])
                      ]),
                      _cache[2] || (_cache[2] = _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          href: "https://fireweb.digiapps.com.co/",
                          target: "_blank",
                          class: "opacity-50 hover:opacity-100 transition-all duration-300 ease-in-out"
                        }, " Fireweb ")
                      ], -1)),
                      _cache[3] || (_cache[3] = _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          href: "https://care.digiapps.com.co/",
                          target: "_blank",
                          class: "opacity-50 hover:opacity-100 transition-all duration-300 ease-in-out"
                        }, " Care ")
                      ], -1)),
                      _cache[4] || (_cache[4] = _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          href: "https://utils.digiapps.com.co/",
                          target: "_blank",
                          class: "opacity-50 hover:opacity-100 transition-all duration-300 ease-in-out"
                        }, " Utils ")
                      ], -1))
                    ])
                  ]),
                  _cache[7] || (_cache[7] = _createStaticVNode("<div class=\"text-left\" data-v-7dafe916><h3 class=\"text-sm text-[var(--text)] font-regular mb-4\" data-v-7dafe916>Contact Us</h3><ul class=\"space-y-2 text-xs text-[var(--text)] font-light pl-1\" data-v-7dafe916><li data-v-7dafe916><a href=\"https://mail.google.com/mail/?view=cm&amp;fs=1&amp;to=support@digiapps.com.co\" target=\"_blank\" class=\"opacity-50 hover:opacity-100 transition-all duration-300 ease-in-out\" data-v-7dafe916> Help Center </a></li><li data-v-7dafe916><a href=\"https://discord.gg/n8NHa6sJbc\" target=\"_blank\" class=\"opacity-50 hover:opacity-100 transition-all duration-300 ease-in-out\" data-v-7dafe916> Discord </a></li></ul></div>", 1)),
                  _createElementVNode("div", _hoisted_13, [
                    _cache[6] || (_cache[6] = _createElementVNode("h3", { class: "text-sm text-[var(--text)] font-regular mb-4" }, "Legal", -1)),
                    _createElementVNode("ul", _hoisted_14, [
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          href: `${_unref(usersLink)}/privacy-policy`,
                          target: "_blank",
                          class: "opacity-50 hover:opacity-100 transition-all duration-300 ease-in-out"
                        }, " Privacy Policy ", 8, _hoisted_15)
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("p", _hoisted_17, "© " + _toDisplayString(_unref(currentYear)) + " digi systems All rights reserved.", 1),
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleTheme && _ctx.toggleTheme(...args))),
                  class: "rounded-full"
                }, [
                  _createElementVNode("img", {
                    src: _ctx.isLight
              ? '/icon/icon-light.svg'
              : '/icon/icon-dark.svg',
                    alt: "theme toggle",
                    class: "w-5 h-5 opacity-70 hover:opacity-100 transition"
                  }, null, 8, _hoisted_18)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}
}

})